const trackPurchaseEvent = (currentUser, payload) => {
  if (!window.TriplePixel) {
    // eslint-disable-next-line no-console
    console.log('triplewhale not configured');
    return;
  }
  const lineItems = (payload?.bundleReservations || []).map((bundle) => ({
    i: bundle.id,
    q: 1,
    v: bundle.id,
  }));
  window.TriplePixel('Purchase', {
    eventId: `purchase-${payload?.paymentId}`,
    email: currentUser?.email,
    phone: currentUser?.phoneNumber,
    firstName: currentUser?.firstName,
    lastName: currentUser?.lastName,
    orderId: `payment-${payload?.paymentId}`,
    lineItems,
    address: {
      zip: currentUser?.primaryAddress?.zipCode,
      city: currentUser?.primaryAddress?.city,
      countryCode: 'US',
      provinceCode: currentUser?.primaryAddress?.state,
    },
  });
  // eslint-disable-next-line no-console
  console.log('triplewhale purchase event sent');
};

const trackTriplePixelPhone = (phone) => {
  if (!phone || typeof window === 'undefined') return;
  if (!window.TriplePixel) {
    // eslint-disable-next-line no-console
    console.log('triplewhale not configured');
    return;
  }
  window.TriplePixel('Contact', { phone: phone });
  // eslint-disable-next-line no-console
  console.log('triplewhale phone event sent', phone);
};

const trackTriplePixelEmail = (email) => {
  if (!email || typeof window === 'undefined') return;
  if (!window.TriplePixel) {
    // eslint-disable-next-line no-console
    console.log('triplewhale not configured');
    return;
  }
  window.TriplePixel('Contact', { email });
  // eslint-disable-next-line no-console
  console.log('triplewhale email event sent');
};

const TripleWhaleTracker = {
  purchase: (userData, payload) => trackPurchaseEvent(userData, payload),
  trackPhone: (phone) => trackTriplePixelPhone(phone),
  trackEmail: (email) => trackTriplePixelEmail(email),
  error: () => {},
};

export default TripleWhaleTracker;
